<template>
    <tr>
        <td>{{ column.title }}</td>
        <td>
            <div class="btn_group">
                <button class="btn btn_xs btn_lgray_line" :disabled="index == 0" @click="handlerMoveToFirst()">
                    <v-icon>mdi-chevron-double-up</v-icon>
                </button>
                <button class="btn btn_xs btn_lgray_line" :disabled="index == 0" @click="handlerMoveToPrevious()">
                    <v-icon>mdi-chevron-up</v-icon>
                </button>
                <button class="btn btn_xs btn_lgray_line" :disabled="index == (columns.length - 1)" @click="handlerMoveToNext()">
                    <v-icon>mdi-chevron-down</v-icon>
                </button>
                <button class="btn btn_xs btn_lgray_line" :disabled="index == (columns.length - 1)" @click="handlerMoveToLast()">
                    <v-icon>mdi-chevron-double-down</v-icon>
                </button>
            </div>
        </td>
        <td class="txt_center">
            <button class="btn btn_s btn_white ico" @click="showColumnSettingPopup"><v-icon>mdi-pencil</v-icon> {{ $t('common.edit') }}</button>
        </td>
    </tr>
</template>

<script>
import { SpaceNavigationAction } from '../Enums/SpaceNavigationAction.js'

export default {
    props: {
        column: Object,
        index: Number,
        columns: Array
    },
    methods: {
        handlerMoveToFirst() {
            this.$emit('updateOrder', SpaceNavigationAction.FIRST, this.index)
        },
        handlerMoveToNext() {
            this.$emit('updateOrder', SpaceNavigationAction.NEXT,  this.index)
        },
        handlerMoveToPrevious() {
            this.$emit('updateOrder', SpaceNavigationAction.PREVIOUS, this.index)
        },
        handlerMoveToLast() {
            this.$emit('updateOrder', SpaceNavigationAction.LAST, this.index)
        },

        showColumnSettingPopup() {
            this.$emit('showColumnSettingPopup', this.column)
        }
    }
}
</script>